import React from 'react';
const BONUSES = [{
  title: 'BONO 1: Clases Salvavidas',
  image: 'https://cdn.magicpatterns.com/uploads/wEeu68FTxQ3mWcTjh5HhkC/BONO_1_CLASES_SALVAVIDAS_SIC.png',
  desc: 'Plan B Docente para cuando falta tiempo o surge un imprevisto.'
}, {
  title: 'BONO 2: Evaluaciones Listas',
  image: 'https://cdn.magicpatterns.com/uploads/rJc8VzdYPV31S145sWiavc/BONO_2_EVALUACIONES_LISTAS_2B_RUBRICAS.png',
  desc: 'Pruebas escritas, trabajos prácticos y rúbricas claras.'
}, {
  title: 'BONO 3: Mapa Anual',
  image: 'https://cdn.magicpatterns.com/uploads/dUiKT2F9JhibPz8EAoq1Hp/BONO_3_MAPA_ANUAL.png',
  desc: 'Un año completo en una sola hoja. Qué dar y en qué orden.'
}, {
  title: 'BONO 4: Banco de Ejemplos',
  image: 'https://cdn.magicpatterns.com/uploads/hcnFcVAUb2GYNe8Y5ETJiV/BONO_4_BANCO_DE_EJEMPLOS.png',
  desc: 'Asientos contables explicados paso a paso para decir en voz alta.'
}];
export function BonusSection() {
  const scrollToPurchase = () => {
    document.getElementById('purchase')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 bg-blue-900 text-white" data-id="element-1">
      <div className="max-w-6xl mx-auto px-4" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <span className="inline-block bg-yellow-400 text-blue-900 font-black px-4 py-2 rounded transform -rotate-2 shadow-lg text-lg mb-4" data-id="element-4">
            GRATIS POR HOY
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-5">
            Llevate estos 4 Bonos Exclusivos
          </h2>
          <p className="text-blue-200 text-xl max-w-2xl mx-auto" data-id="element-6">
            Herramientas complementarias para blindar tu año escolar. Incluidos
            sin cargo con tu compra.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-7">
          {BONUSES.map((bonus, index) => <div key={index} className="bg-blue-800 rounded-xl overflow-hidden shadow-xl border border-blue-700 hover:border-orange-400 transition-all duration-300 cursor-pointer group" onClick={scrollToPurchase} data-id="element-8">
              <div className="relative overflow-hidden" data-id="element-9">
                <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors z-10" data-id="element-10"></div>
                <img src={bonus.image} alt={bonus.title} className="w-full h-auto transform group-hover:scale-105 transition-transform duration-500" data-id="element-11" />
              </div>
              <div className="p-6" data-id="element-12">
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-orange-400 transition-colors" data-id="element-13">
                  {bonus.title}
                </h3>
                <p className="text-blue-200" data-id="element-14">{bonus.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}